export const COMPETENCIES_BY_LANGUAGE = {
    English: [
        "Empathy",
        "Conflict Resolution",
        "Communication Skills",
        "Solution Orientation",
        "Customer Orientation",
        "Assertiveness",
        "Active Listening",
        "Questioning",
        "Conversation Steering",
        "Persuasiveness",
        "Situation Awareness",
        "Objection Handling",
        "Deal Framing",
        "Coaching Skills",
        "Constructive Feedback",
        "Goal Setting & Action Planning"
      ],
    Dutch: [
        "Empathie",
        "Conflicthantering",
        "Communicatievaardigheden",
        "Oplossingsgerichtheid",
        "Klantgerichtheid",
        "Assertiviteit",
        "Actief Luisteren",
        "Doorvragen",
        "Gesprekssturing",
        "Overtuigingskracht",
        "Contextbewustzijn",
        "Omgaan met Bezwaren",
        "Dealframing",
        "Coachingsvaardigheden",
        "Constructieve Feedback",
        "Doelstellingen en Actieplanning"
      ],
    French: [
        "Empathie",
        "Gestion des conflits",
        "Compétences en communication",
        "Orientation solution",
        "Orientation client",
        "Assertivité",
        "Écoute active",
        "Questionnement approfondi",
        "Conduite de l'entretien",
        "Force de persuasion",
        "Conscience de la situation",
        "Gestion des objections",
        "Cadrage de l'offre",
        "Compétences de coaching",
        "Feedback constructif",
        "Définition d'objectifs et planification d'actions"
      ],
};

export function competencySelection(saved, language) {
  const key = { english: 'English', en: 'English', dutch: 'Dutch', nl: 'Dutch', flemish: 'Dutch', 'nl-be': 'Dutch', french: 'French', fr: 'French' }[String(language).toLowerCase()] || 'English';
  const options = [...COMPETENCIES_BY_LANGUAGE[key]];
  const normalize = value => value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
  let values = saved;
  if (typeof values === 'string') {
    try { values = JSON.parse(values); } catch { values = [values]; }
  }
  if (!Array.isArray(values)) values = [];
  const selected = [...new Set(values.filter(v => typeof v === 'string' && v.trim()).map(value => {
    const name = value.split('–')[0].trim();
    for (const list of Object.values(COMPETENCIES_BY_LANGUAGE)) {
      const index = list.findIndex(item => normalize(item) === normalize(name));
      if (index >= 0) return options[index];
    }
    return value.trim(); // Keep legacy values visible; never silently discard saved data.
  }))];
  return { options: [...new Set([...options, ...selected])], selected };
}
